import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=36deaa53&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=36deaa53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36deaa53",
  null
  
)

export default component.exports